// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bic_j bic_i bic_bc bic_r bic_st","QualityCheckboxes__quality":"ex_b"};